export enum CacheConstants {
    USER_ID,
    INTEGRATION,
}
